import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/PasswordReset/PasswordReset.js
const PasswordReset = createSectionForm({
  icon: "lock-password-line",
  title: "Password Reset",
  fields: [{ name: "title", label: "Heading", placeholder: "Reset Your Password" }],
});

export default PasswordReset;
